// ─── Gallery Slider ─────────────────────────────────────────────────────────
function initSwiper(el) {
    new Swiper(el, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 34,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
            768:  { spaceBetween: 48 },
            991:  { spaceBetween: 56 },
            1024: { spaceBetween: 65 },
            1199: { spaceBetween: 98 },
            1921: { slidesPerView: 4 },
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    // Lazy-init Swiper — only when the gallery scrolls into view (200px buffer).
    document.querySelectorAll('.gallery-slider').forEach(function (el) {
        if (typeof Swiper === 'undefined') return;
        if (!('IntersectionObserver' in window)) {
            initSwiper(el);
            return;
        }
        var io = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                obs.unobserve(entry.target);
                initSwiper(entry.target);
            });
        }, { rootMargin: '200px' });
        io.observe(el);
    });
});
